import { createResourcePermissionStore } from '@/stores/createResourcePermissionStore';
import { useCurrentProjectSwitchStore, useUserSwitchStore } from '@/stores/useSwitchStore';
import { PermissionMeta } from 'common-module/src/config/permission';
import { useProjectPermissionStore, useProjectRoleStore, useProjectSwitchStore } from '@/stores/useProjectDataStore';
import { useGetter } from 'common-module/src/util/useVuex';

export const useCurrentProjectRoleResourceStore = createResourcePermissionStore('user/project/role');
export const useCurrentProjectPermissionResourceStore = createResourcePermissionStore('user/project/permission');
export const useUserRoleResourceStore = createResourcePermissionStore('user/role', {
  dependencies: [useCurrentProjectRoleResourceStore]
});
export const useUserPermissionResourceStore = createResourcePermissionStore('user/permission', {
  dependencies: [useCurrentProjectPermissionResourceStore]
});
export const useRightsVersionResourceStore = createResourcePermissionStore('user/rights/version');

export const checkPermission = (meta?: PermissionMeta, opts?: {
  projectId?: number
  getters?: Record<string, any>
}) => {
  const {
    projectSwitch, userSwitch,
    roles, roleAnd,
    permissions, rightVersion,
    notAccessFunctions, fallback = []
  } = meta || {};

  const userRoleResourceStore = useUserRoleResourceStore();
  const userPermissionResourceStore = useUserPermissionResourceStore();
  const userSwitchStore = useUserSwitchStore();
  const projectSwitchStore = useCurrentProjectSwitchStore();
  const allProjectPermissionStore = useProjectPermissionStore();
  const allProjectRoleStore = useProjectRoleStore();
  const allProjectSwitchStore = useProjectSwitchStore();
  const rightsVersionResourceStore = useRightsVersionResourceStore();

  // 判断后备条件，如果任意一个后备条件满足，则返回true
  const checkFallbackConditions = (): boolean => fallback.some(item => checkPermission(item));

  // 判断权限资源
  if (opts?.projectId) {
    if (!userPermissionResourceStore.hasSelfPermission(permissions) &&
      !allProjectPermissionStore.hasPermission(opts.projectId, permissions)) {
      return checkFallbackConditions();
    }
  } else {
    if (!userPermissionResourceStore.hasPermission(permissions)) {
      return checkFallbackConditions();
    }
  }
  // 判断角色
  if (opts?.projectId) {
    if (!userRoleResourceStore.hasSelfPermission(roles, roleAnd) &&
    !allProjectRoleStore.hasRole(opts.projectId, roles, roleAnd)) {
      return checkFallbackConditions();
    }
  } else {
    if (!userRoleResourceStore.hasPermission(roles, roleAnd)) {
      return checkFallbackConditions();
    }
  }
  // 判断a/b开关
  if (!userSwitchStore.isSwitch(userSwitch)) {
    return checkFallbackConditions();
  }
  if (opts?.projectId) {
    if (!allProjectSwitchStore.isSwitchOn(opts.projectId, projectSwitch)) {
      return checkFallbackConditions();
    }
  } else {
    if (!projectSwitchStore.isSwitch(projectSwitch)) {
      return checkFallbackConditions();
    }
  }
  // 判断版本
  if (!rightsVersionResourceStore.hasPermission(rightVersion)) {
    return checkFallbackConditions();
  }
  // 判断无权限getter函数
  if (notAccessFunctions?.length) {
    if (notAccessFunctions.some(getter => {
      if (opts?.getters && Reflect.has(opts.getters, getter)) {
        return opts.getters[getter];
      }
      return useGetter(getter);
    })) {
      return checkFallbackConditions();
    }
  }

  return true;
};

export const isProjectInnerCollaborator = (projectId?: number) => {
  return checkPermission({
    roles: ['innerCollaborator']
  }, {
    projectId
  });
};

export const isProjectInnerCollaboratorButNotAdmin = (projectId?: number) => {
  return isProjectInnerCollaborator(projectId) && !checkPermission({
    roles: ['organizationAdmin', 'organizationOwner']
  }, {
    projectId
  });
};
